import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import CustomDataGrid from "../../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Category } from "@mui/icons-material";
import { EQUIPMENT_GROUPS_ENDPOINT } from "../../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../../contexts/auth";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from "../../../../components/ui/customDataGrid/filterOperators";

interface EquipmentModel {
  id: string;
  name?: string;
  display_name?: string;
}

export default function EquipmentGroupsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewEquipmentGroups = useHasPermission("service.view_equipmentgroup");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: "name",
      headerName: t("Name"),
      flex: 1,
      minWidth: 200,
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: "equipment_models",
      headerName: t("Equipment Models"),
      flex: 2,
      minWidth: 260,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 1 }}>
          {(params.row.equipment_models as EquipmentModel[] | undefined)?.map((equipmentModel) => (
            <Chip
              key={equipmentModel.id}
              label={equipmentModel.display_name || equipmentModel.name}
              size="small"
            />
          ))}
        </Box>
      ),
    },
    {
      field: "equipment_count",
      headerName: t("Models"),
      width: 140,
      sortable: false,
      filterable: false,
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/statistics/equipment-groups/${id}`);
  };

  if (!canViewEquipmentGroups) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Category />}
      title={t("Equipment Groups")}
      url={EQUIPMENT_GROUPS_ENDPOINT}
      gridSettingsKey="EQUIPMENT_GROUPS"
      columns={columns}
      refreshEventName="equipmentGroupAdded"
      onRowClick={handleRowClick}
    />
  );
}
